import { Expose, Transform, Type } from "class-transformer";
import RebalanceItem from "./rebalanceItem";

/**
 * A portfolio rebalance plan, with the necessary changes of buying and selling securities as its rebalance items.
 */
export default class RebalancePlan {
  /** The items that need to be done in order to rebalance the portfolio  */
  @Type(() => RebalanceItem)
  @Expose() rebalanceItems: RebalanceItem[];

  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  createdAt: Date;

  @Transform(({ value }) => value && value.toISOString(), { toPlainOnly: true })
  @Transform(({ value }) => value && new Date(value), { toClassOnly: true })
  updatedAt: Date;
  /**
   * @param id GUID of this rebalance item.
   * @param portfolioId ID of the portfolio to which this portfolio component belongs to.
   * @param finished Indicates if plan has been accepted by the user as finished.
   * @param createdAt When this rebalance plan has been created.
   * @param updatedAt When was the last time this rebalance plan was updated.
   */
  constructor(
    public id: string | undefined,
    public portfolioId: string,
    public finished: boolean = false,
    createdAt: Date = new Date(),
    updatedAt: Date = new Date()
  ) {
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.rebalanceItems = [];
  }

}